import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { ScrollArea } from './ui/scroll-area';

export default function RefundPolicyDialog({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#0f0f16] border-purple-900/60 text-gray-200 max-w-2xl">
        <DialogHeader>
          <DialogTitle className="gradient-text text-2xl">રિફંડ પૉલિસી</DialogTitle>
        </DialogHeader>
        <ScrollArea className="max-h-[60vh] pr-4">
          <div className="text-sm leading-relaxed space-y-3">
            <p><strong className="text-white">1. બુકિંગ કેન્સિલેશન:</strong> ગ્રાહક સર્વિસ તારીખથી ઓછામાં ઓછા 24 કલાક પહેલા બુકિંગ રદ કરાવી શકે છે.</p>
            <p><strong className="text-white">2. બુકિંગ ટોકન (₹100):</strong> ₹100 ની બુકિંગ ટોકન રકમ નોન-રિફંડેબલ છે. પણ સર્વિસ સમયે કુલ બિલમાંથી મજરાતમાં આવશે.</p>
            <p><strong className="text-white">3. AMC બુકિંગ (25% ભરેલું):</strong> AMC માટે ભરેલ 25% રકમ રદ કરાવામાં આવશે જો સર્વિસ શરુ થયા પહેલાં 24 કલાક માં રદ કરવામાં આવે. ત્યાર બાદ કોઈ રિફંડ મળશે નહીં.</p>
            <p><strong className="text-white">4. ફ્લ પેમેન્ટ:</strong> પૂરી ચૂકવણી ભરેલ બુકિંગમાં સર્વિસ શરૂ થયા પછી રિફંડ શક્ય નથી. શરુ કરવા પહેલાં 24 કલાક માં કન્સ્ટ્રક્ટિવ કારણ સાથે અરૂ કરવું પડશે.</p>
            <p><strong className="text-white">5. સમય: </strong> રિફંડ મંજૂર થાય પછી 5-7 વ્યવસાયિક દિવસમાં મૂળ પેમેન્ટ મોડમાં રકમ આવશે.</p>
            <p><strong className="text-white">6. વિવાદ:</strong> કોઈ પણ વિવાદની સ્થિતિમાં વડોદરા કોર્ટનું ક્ષેત્રાધિકાર રહેશે.</p>
            <p className="text-gray-400">વધુ માહિતી માટે કૉલ કરો: +91 84606 92482</p>
          </div>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
}
